import {GET_ADHAR_CARD_KYC_IMAGE, GET_ADHAR_CARD_KYC_REQ,GET_ADHAR_CARD_SUCCESS, ADHAR_CARD_ERROR,GET_ADHAR_CARD_IMAGE_RESET } from "../actionType";

const initialState = {
    isLoading: true,
    adharcardImage: null,
    adharcardValue: null,
    adharcardData: null,
    adharcardError: null
}

const adharCardReducer = (state = initialState, action: any) => {
    const { type, payload } = action;

    switch (type) {

        case GET_ADHAR_CARD_KYC_IMAGE:
            return {
                ...state,
                adharcardImage: payload
            }

        case GET_ADHAR_CARD_KYC_REQ:
            return {
                ...state,
                adharcardValue: payload
            }

        case GET_ADHAR_CARD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                adharcardData: payload
            }

        case ADHAR_CARD_ERROR:
            return {
                ...state,
                isLoading: false,
                adharcardError: payload
            }
        case GET_ADHAR_CARD_IMAGE_RESET:
            return {
                ...state,
                isLoading: false,
                adharcardImage: null
            }
        default:
            return {
                state
            }
    }
}

export default adharCardReducer